import { EntityDescription } from 'framework/EntityDescription/entityDescription';
import { makeAutoObservable } from 'mobx';
import React from 'react';

class CeeviewEntityDragAndDropStore {
	dragData: EntityDescription;

	constructor() {
		makeAutoObservable(this);
	}

	startDragging(e: React.DragEvent, dragData: EntityDescription) {
		this.dragData = dragData;
		e.dataTransfer.setData('ceeview/entity', '');
	}

	stopDragging() {
		this.dragData = null;
	}
}

const instance = new CeeviewEntityDragAndDropStore();

export { instance as CeeviewEntityDragAndDropStore };
